/**
 * API pública de interpolação dinâmica do CMS.
 *
 * - `interpolate({ structure, template })` — orquestrador. Use como entry
 *   point default em componentes de seção. Cada leaf consumer escolhe
 *   `.text` (atributos HTML, URLs), `.node` (JSX inline), `.image`
 *   (image single-token), `.gallery` (gallery single-token), `.media`
 *   (media single-token), `.boolean` (boolean coercion), `.list`
 *   (array single-token), `.colors` ou `.unit` (unidade do canal apontada
 *   por um campo `unit_id`).
 *
 * - `interpolateString` / `interpolateNodes` / `extractImage` /
 *   `extractGallery` — especialistas expostos para casos pontuais
 *   (ex.: SEO usa `interpolateString` direto).
 *
 * Helpers em `internal/` não são parte da API pública e não devem ser
 * importados de fora deste módulo.
 */
export { interpolate, type InterpolateResult } from "./interpolate";
export { interpolateString } from "./core/interpolateString";
export { interpolateNodes } from "./core/interpolateNodes";
export { extractImage } from "./core/extractImage";
export { extractGallery } from "./core/extractGallery";
export { extractMedia } from "./core/extractMedia";
export { extractBoolean } from "./core/extractBoolean";
export { extractList } from "./core/extractList";
export { extractPlans } from "./core/extractPlans";
export { extractTags } from "./core/extractTags";
export { extractUnit, type ResolvedUnit } from "./core/extractUnit";
export type {
  DynamicStructure,
  InterpolateParams,
  InterpolateInput,
  InferParams,
  InferContext,
  FieldMetadata,
  FieldMetadataItem,
  InterpolateOptions,
  ExtractedImage,
  ExtractedMedia,
  ExtractedGalleryImage,
  ColorItem,
  ColorValue,
  ExtractedRepeaterItem,
} from "./types";
